import React, { FunctionComponent } from 'react';

interface Props {
  fill?: string;
}

export const UserSVG: FunctionComponent<Props> = ({ fill }) => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill={fill ? fill : 'white'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 4.11111V32.8889C0 35.15 1.85 37 4.11111 37H32.8889C35.15 37 37 35.15 37 32.8889V4.11111C37 1.85 35.15 0 32.8889 0H4.11111C1.85 0 0 1.85 0 4.11111ZM24.6667 12.3333C24.6667 15.8278 21.9944 18.5 18.5 18.5C15.0056 18.5 12.3333 15.8278 12.3333 12.3333C12.3333 8.83889 15.0056 6.16667 18.5 6.16667C21.9944 6.16667 24.6667 8.83889 24.6667 12.3333ZM6.16667 28.7778C6.16667 24.6667 14.3889 22.4056 18.5 22.4056C22.6111 22.4056 30.8333 24.6667 30.8333 28.7778V30.8333H6.16667V28.7778Z" />
    </svg>
  );
};
